import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { saveMegaMenu } from "../../features/MegaMenu/MegaMenuSlice";
import CmsBlock from "../CmsBlock/cmsBlock";
import "./BannerModal.css";
import CountdownTimer from "../CountdownTimer/CountdownTimer";

const IDENTIFIER = "home-popup";
const SALE_START_TIME = new Date("2025-04-24T17:58:00");

const BannerModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [isSaleStarted, setIsSaleStarted] = useState(false);
  const modalBodyRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem("modalClosed", "true");
  };

  useEffect(() => {
    const modalClosed = localStorage.getItem("modalClosed");
    if (!modalClosed) {
      setShowModal(true);
    }

    const interval = setInterval(() => {
      const now = new Date();
      if (now >= SALE_START_TIME) {
        setIsSaleStarted(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    dispatch(saveMegaMenu(false));
  }, []);

  useEffect(() => {
    if (showModal) {
      handleClose();
    }
  }, [location]);

  useEffect(() => {
    const modalNode = modalBodyRef.current;
    if (modalNode && isSaleStarted) {
      const handleClick = () => {
        handleClose();
      };
      modalNode.addEventListener("click", handleClick);
      return () => {
        modalNode.removeEventListener("click", handleClick);
      };
    }
  }, [showModal, isSaleStarted]);

  return (
    <Modal className="home-modal" show={showModal} centered>
      <Modal.Body
        ref={modalBodyRef}
        style={{ padding: "0px", position: "relative" }}
      >
        <>
          <div style={{ display: !isSaleStarted ? "block" : "none" }}>
            <CountdownTimer
              saleStartTime={SALE_START_TIME}
              setIsSaleStarted={setIsSaleStarted}
            />
          </div>
          <div style={{ display: !isSaleStarted ? "none" : "block" }}>
            <Button
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                background: "black",
              }}
              variant="secondary"
              onClick={handleClose}
            >
              X
            </Button>

            <CmsBlock IDENTIFIER={IDENTIFIER} />
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default BannerModal;
